interface TabsProps {
  type: string;
  sectionId: string;
  colorScheme: string;
  tabs: any[];
}

const Tabs = ({ type, sectionId, colorScheme, tabs }: TabsProps) => {
  const normalizedData = {
    type,
    sectionId,
    colorScheme,
    tabs
  }

  return normalizedData
}

export default Tabs
